window.addEventListener('load', () => {
  // Native scrolling is intentional. A permanent Lenis/GSAP ticker competed
  // with the homepage WebGL and canvas sections on every animation frame.

  // --- 影片智慧 Lazy-Load 與視口感知暫停 ---
  function initLazyVideos() {
    const lazyVideos = document.querySelectorAll('.lazy-video');
    if ('IntersectionObserver' in window) {
      const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const video = entry.target;
          if (entry.isIntersecting) {
            if (video.getAttribute('preload') === 'none') {
              video.setAttribute('preload', 'auto');
            }
            video.play().catch(err => {});
          } else {
            video.pause();
          }
        });
      }, {
        rootMargin: '120px 0px 120px 0px'
      });
      lazyVideos.forEach(video => {
        videoObserver.unobserve(video);
        videoObserver.observe(video);
      });
    } else {
      lazyVideos.forEach(video => {
        video.setAttribute('preload', 'auto');
        video.play().catch(err => {});
      });
    }
  }

  // --- 磁吸流光邊框 (Magnetic Border Glow) 引擎 ---
  function handleCardMouseMove(e) {
    const card = e.currentTarget;
    const rect = card.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    card.style.setProperty('--mx', `${x}px`);
    card.style.setProperty('--my', `${y}px`);
  }

  function initMagneticBorders() {
    const cards = document.querySelectorAll('.moztech-bento-card, .spotlight-card');
    cards.forEach(card => {
      card.removeEventListener('mousemove', handleCardMouseMove);
      card.addEventListener('mousemove', handleCardMouseMove);
    });
  }

  // 初始化所有引擎
  initLazyVideos();
  initMagneticBorders();

  // 支援 Shopify Theme Editor 熱重載時重啟引擎
  document.addEventListener('shopify:section:load', () => {
    setTimeout(() => {
      initLazyVideos();
      initMagneticBorders();
    }, 100);
  });
});
